import { useSearchParams } from 'react-router-dom';

export const useFocusedCommentSearchParams = () => {
  const [searchParams] = useSearchParams();
  const commentId = searchParams.get('comment_id');
  const replyId = searchParams.get('reply_id');

  return {
    commentId: Number(commentId) || undefined,
    replyId: Number(replyId) || undefined,
  };
};
